import { lazyWithPreload } from '@kk/shared/utils/async';

const Info = lazyWithPreload(async () => await import('./index'));

export default {
  id: 'info',
  path: '/info',
  element: <Info />,
} as const;
